<template>
<div class="search_area" v-if="$store.state.ui.show_search_area">
<div class="search_header">
<span class="material-icons-outlined md-36 mr-3 text-primary p-link" @click="closeSearch"    >
    cancel
    </span>	

</div>


</div>	
</template>

<script>
export default {

  name: 'SearchArea',

  data () {
    return {

    }
  },
  methods:{
  	closeSearch()
  	{

        this.$store.dispatch('ui/setShowSearchArea',false)
  	},
  }
}
</script>

<style lang="css" scoped>
</style>